! function() {
    "use strict";

    function t() {
        const t = {};
        return t.windowHeight = Math.min(window.screen.height, window.innerHeight), t.footerHeight = e('[data-section-type*="footer"]'), t.headerHeight = e("[data-header-height]"), t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0, t.collectionNavHeight = e("[data-collection-nav]"), t.logoHeight = function() {
            const t = e("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t
    }

    function e(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0
    }! function() {
        if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
        if (window.matchMedia("(orientation: landscape)").matches);
    }(), window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);

    function i() {
        return (document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth) >= window.theme.sizes.small
    }
    const s = "[data-timeline-rows]",
        o = "[data-timeline-row]",
        n = "[data-timeline-row-editor]",
        r = "[data-timeline-button]",
        l = "[data-block-scroll]",
        h = "is-selected";
    customElements.get("timeline-component") || customElements.define("timeline-component", class extends HTMLElement {
        constructor() {
            super(), this.rows = this.querySelectorAll(o), this.rows.length < 2 || (this.rowsWidth = 0, this.rowsHeight = [], this.holderTop = this.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.offsetHeight, this.buttons = this.querySelectorAll(r), this.rowsHolder = this.querySelector(s), this.requestAnimation = null, this.isDesktopView = i(), this.isScrollEnabled = !1, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = () => this.resizeEvents())
        }
        connectedCallback() {
            this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition())), this.isDesktopView && !this.isScrollEnabled && (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.addEventListener("scroll", this.scrollEvent), document.addEventListener("theme:resize:width", this.resizeEvent), this.buttons.length && this.buttons.forEach(((e, s) => {
                e.addEventListener("click", (e => {
                    e.preventDefault();
                    const n = e.currentTarget.closest(o);
                    if (n)
                        if (i()) {
                            const e = Math.max(...this.rowsHeight),
                                i = this.holderHeight / this.rows.length,
                                o = this.getBoundingClientRect().top;
                            (e => {
                                let {
                                    stickyHeaderHeight: i
                                } = t();
                                window.scrollTo({
                                    top: e + window.scrollY - i,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            })((s > 0 && e < i ? i * s + o : o) + 1)
                        } else {
                            const t = 16,
                                e = n.offsetLeft - t;
                            this.rowsHolder.scrollTo({
                                left: e,
                                behavior: "smooth"
                            })
                        }
                }))
            }))
        }
        resizeEvents() {
            this.holderTop = this.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.offsetHeight, this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame((() => this.calculatePosition()));
            const t = i();
            t && !this.isScrollEnabled ? (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)) : !t && this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent))
        }
        scrollEvents(t) {
            if (!this.requestAnimation) {
                const e = t.currentTarget;
                this.requestAnimation = requestAnimationFrame((() => this.calculatePosition(e)))
            }
        }
        removeAnimationFrame() {
            this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), this.requestAnimation = null)
        }
        calculateRowsDimensions() {
            if (this.rows.length) {
                this.rowsHeight = [], this.rowsWidth = 0;
                let t = 0;
                this.rows.forEach(((e, i) => {
                    if (this.rowsHeight.push(e.offsetHeight), this.rowsWidth += e.offsetWidth + parseInt(getComputedStyle(e).marginRight), window.Shopify.designMode) {
                        const s = this.querySelectorAll(n);
                        s.length && (t += e.offsetHeight, s[i]?.style.setProperty("--row-height-min", `${e.offsetHeight}px`), s[i + 1]?.style.setProperty("--row-top-mobile", `${t}px`))
                    }
                }))
            }
        }
        calculatePosition(t = null) {
            this.removeAnimationFrame();
            const e = i(),
                s = this.holderHeight / this.rows.length;
            let o = this.holderTop;
            const n = window.innerHeight,
                r = window.scrollY + 1.5 * n;
            let l = 0;
            if (!e && t) {
                const e = t.scrollLeft - 16,
                    i = t.offsetWidth;
                l = e / (this.rowsWidth - i) * 100, this.style.setProperty("--percent-mobile", `${l}%`)
            }
            e && (r < this.holderTop || r > this.holderTop + this.holderHeight + n) || this.rows.forEach(((t, i) => {
                if (i > 0) {
                    const i = t.offsetLeft / this.rowsWidth * 100;
                    let n = l > i;
                    e && (n = o + s < r, o - s < r && t.previousElementSibling?.style.setProperty("--percent-desktop", (r - o) / s * 100 + "%")), t.classList.toggle(h, n)
                }
                o += s
            }))
        }
        disconnectedCallback() {
            this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.removeEventListener("scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent)
        }
        onBlockSelect(t) {
            const e = this.querySelector(l);
            if (e) {
                const i = t.srcElement,
                    s = [...i.parentElement.children].indexOf(i),
                    o = this.rows[s];
                o && e.scrollTo({
                    top: 0,
                    left: o.offsetLeft,
                    behavior: "smooth"
                })
            }
        }
    })
}();